import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { getAllStateListFailure, getAllStateListSuccess } from '../../actions/publicActions/getAllStateActions';
import store from '../../configStore';

function* getAllStateList({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAllState,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_ALL_STATE_SUCCESS status :", response.data.status);
        console.log("GET_ALL_STATE_SUCCESS data :", response.data.response);
        console.log("GET_ALL_STATE_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getAllStateListSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_ALL_STATE_FAILURE status :", error?.response?.status);
        console.log("GET_ALL_STATE_FAILURE data:", error?.response?.data);
        console.log("GET_ALL_STATE_FAILURE error :", error);
        console.log('====================================');
        yield put(getAllStateListFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getAllStateListSaga() {
    yield takeLatest(actionTypes.GET_ALL_STATE_REQUEST, getAllStateList);
}

export default getAllStateListSaga;
